import * as React from 'react'
import { OneLayoutConnected } from './OneLayoutConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const OneLayoutExamples = () => {
  return (
    <div className="OneLayoutExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <OneLayoutConnected />
      </Provider>
    </div>
  )
}
